import { ref } from 'vue'

// 创建事件总线
class EventBus {
  private events: Map<string, Function[]> = new Map()

  // 监听事件
  on(event: string, callback: Function) {
    if (!this.events.has(event)) {
      this.events.set(event, [])
    }
    this.events.get(event)!.push(callback)
  }

  // 移除事件监听
  off(event: string, callback?: Function) {
    if (!this.events.has(event)) return
    
    if (callback) {
      const callbacks = this.events.get(event)!
      const index = callbacks.indexOf(callback)
      if (index > -1) {
        callbacks.splice(index, 1)
      }
    } else {
      this.events.delete(event)
    }
  }

  // 触发事件
  emit(event: string, ...args: any[]) {
    if (!this.events.has(event)) return
    
    const callbacks = this.events.get(event)!
    callbacks.forEach(callback => {
      try {
        callback(...args)
      } catch (error) {
        console.error(`Error in event callback for ${event}:`, error)
      }
    })
  }

  // 一次性监听
  once(event: string, callback: Function) {
    const onceCallback = (...args: any[]) => {
      callback(...args)
      this.off(event, onceCallback)
    }
    this.on(event, onceCallback)
  }
}

// 创建全局事件总线实例
export const eventBus = new EventBus()

// 导出响应式的事件总线（可选）
export const useEventBus = () => {
  return eventBus
}
